import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Box, Button, Icons } from 'baukasten';

import { CurrentAccount } from 'types/CurrentAccount';

import messages from '../messages';

export const LicenseUpgradeModalFooter = ({
  onClose,
  account,
  canSelfUpgradeViewerLicense,
  didUpgradeSuccessfully,
  isLoading,
  onUpgradeClick,
}: {
  onClose: () => void;
  account: CurrentAccount;
  canSelfUpgradeViewerLicense: boolean;
  didUpgradeSuccessfully?: boolean;
  isLoading?: boolean;
  onUpgradeClick?: () => void;
}) => {
  const { customLicenseUpgradeLink } = account;

  const openCustomLicenseUpgradeLink = () => {
    window.open(customLicenseUpgradeLink, '_blank');
  };

  const handleStartContributing = () => {
    window.location.reload();
  };

  let buttonContent: React.ReactNode;

  if (canSelfUpgradeViewerLicense) {
    if (didUpgradeSuccessfully) {
      buttonContent = (
        <Button
          variant="contained"
          onClick={handleStartContributing}
          startIcon={Icons.Check}
        >
          <FormattedMessage {...messages.startContributing} />
        </Button>
      );
    } else {
      buttonContent = (
        <Button
          variant="contained"
          onClick={onUpgradeClick}
          disabled={isLoading}
          startIcon={Icons.Star}
        >
          <FormattedMessage
            {...(isLoading ? messages.upgrading : messages.getStandardLicense)}
          />
        </Button>
      );
    }
  } else if (customLicenseUpgradeLink) {
    buttonContent = (
      <Button
        variant="contained"
        onClick={openCustomLicenseUpgradeLink}
        startIcon={Icons.ExternalLink}
      >
        <FormattedMessage {...messages.requestUpgrade} />
      </Button>
    );
  } else {
    buttonContent = (
      <Button variant="contained" onClick={onClose}>
        <FormattedMessage {...messages.understood} />
      </Button>
    );
  }

  return (
    <Box display="flex" justifyContent="flex-end">
      {buttonContent}
    </Box>
  );
};
